<template>
  <div class="">
    <div class="flags" v-if="languages.length > 1">
      <div class="flag" v-for="language in languages">
        <a :href="LanguageLink(language.slug)">
          <img :src="language.image" :alt="language.name"/>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {defaultLanguage} from "@/router";
import {mapGetters} from "vuex";

export default {
  name: "LanguageChanger1",
  data() {
    return {
      defaultLanguage,
    }
  },
  computed: {
    ...mapGetters({
      languages: "Language/getLanguages"
    })
  },
  methods: {
    LanguageLink(language) {
      if (language === this.defaultLanguage) {
        return window.location.origin
      } else {
        return window.location.origin + '/' + language
      }
    },
  }
}
</script>

<style scoped>
/* use below css to find svg of flag
steps:
1.import icon cdn
 @import 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@6.6.6/css/flag-icons.min.css';
2. find your flag with html example: <span class="fi fi-ca">
3. find svg on network and save it.
 */
.flag {
  height: auto;
  display: inline-block;
  margin: 0 0 0 10px;
}

.flag, .flag * {
  width: 40px;
}
</style>